import React from 'react';
import { Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import styled from 'styled-components';

import { FormFieldLabel } from './FormFieldLabel';

export const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label {
    padding-bottom: 0px;
  }
`;

export type FormInputProps = {
  name: string | string[];
  label?: string;
  rows?: number;
  required?: boolean;
};

export const FormTextArea: React.FC<FormInputProps> = ({ name, label, required, rows = 5 }) => {
  return (
    <StyledFormItem
      name={name}
      style={{ marginBottom: '5px' }}
      label={label ? <FormFieldLabel required={required}>{label}</FormFieldLabel> : null}
    >
      <TextArea rows={rows} />
    </StyledFormItem>
  );
};
